import PropTypes from 'prop-types';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { download } from '@cld/file-download';
import CopyToClipboard from '@cld/copy-to-clipboard';
import Icon from '@cld/icon';
import ListItemLayout from '@cld/list-item-layout';
import theme from '@cld/theme-helper';

import { messages } from '../../../i18n';

const PopoverActions = styled.div`
  display: flex;
  flex-direction: column;

  ${ListItemLayout} {
    padding: ${theme`spacing.xs`} ${theme`spacing.sm`};
    cursor: pointer;
  }

  div svg {
    color: ${theme`color.gray70`};
  }
`;

export const PopoverOverlay = ({ urlForCopy, urlForDownload }) => {
  const { formatMessage } = useIntl();
  const onAssetDownload = (event) => download(urlForDownload);

  return (
    <PopoverActions onClick={(event) => event.stopPropagation()}>
      <ListItemLayout size="md" onClick={onAssetDownload} data-test="download-button">
        <Icon name="fileDownload" />
        <FormattedMessage {...messages.assetDownload} />
      </ListItemLayout>

      <CopyToClipboard copiedValue={urlForCopy} tooltipAfterText={formatMessage(messages.assetCopyUrlSuccess)}>
        <ListItemLayout size="md">
          <Icon name="fetch" />
          <FormattedMessage {...messages.assetCopyUrl} />
        </ListItemLayout>
      </CopyToClipboard>
    </PopoverActions>
  );
};

PopoverOverlay.propTypes = {
  urlForCopy: PropTypes.string.isRequired,
  urlForDownload: PropTypes.string.isRequired,
};
